import styled from 'styled-components'

import { helpers } from 'styles'

export const Content = styled.div`
	color: ${helpers.color.textContrast};
	max-width: 1200px;
	padding: 0 12px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 48px;
`
